//
// FillOutlineDisplay.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./GTLModel";

var FillOutlineDisplay = createModule("gtl::FillOutlineDisplay", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        outline: 2,
        fill: 2,
    },
    ,
    ,
    {
        set: [0,2,2],
        setALL: [0],
    },
    {
        _create: [4],
        getValueFromString: [1,7,1,1],
    },
    ,
]);
export default FillOutlineDisplay;
